import * as Immutable from "immutable";

export const defaultHandoffSettings = Immutable.Map({
  integrations: Immutable.Map({
    zendesk: Immutable.Map({
      name: "zendesk",
      enabled: false,
      email: "",
      token: "",
      subdomain: ""
    })
  })
});
